import { render, staticRenderFns } from "./dialog-video.vue?vue&type=template&id=0c4a5710&scoped=true"
import script from "./dialog-video.vue?vue&type=script&lang=js"
export * from "./dialog-video.vue?vue&type=script&lang=js"
import style0 from "./dialog-video.vue?vue&type=style&index=0&id=0c4a5710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a5710",
  null
  
)

export default component.exports